import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { compose, lifecycle } from 'recompose'
import { Icon, Step, } from 'semantic-ui-react'
import { Cont } from './styled'
import { getDownPaymentApprover } from 'ducks/downPayment'
import Approves from './Approvers'

const DPStep = (props) => {
  const {
    valueForm,
    approvers
  } = props
  return (
    <Cont>
      <Step.Group size='mini'>
        <Step className={`${valueForm && valueForm.status === 6 ? 'stepWait' : 'stepComplete'}`}>
          <Icon name='plus circle' />
          <Step.Content>
            <Step.Title>{`${valueForm && valueForm.status !== 0 ? 'Created' : 'Create'}`}</Step.Title>
          </Step.Content>
        </Step>
        <Step className={`${valueForm && valueForm.status != 0 ? valueForm && valueForm.status === 4 ? 'stepComplete' : valueForm && valueForm.status === 6 ? 'stepWait' : 'stepInprocess' : 'stepWait'}`}>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}></div>
          <Icon name='forward' />
          <Step.Content>
            <Step.Title>In Process</Step.Title>
            {getStepActivity()}
          </Step.Content>
          <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
            <Approves approvers={approvers} status={valueForm && valueForm.status} trigger={<Icon name='sort numeric down' circular inverted link />} />
          </div>
        </Step>
        <Step className={`${valueForm && valueForm.status === 4 ? 'stepComplete' : valueForm && valueForm.status === 6 ? 'stepCancelled' : 'stepWait'}`}>
          <Icon name='check circle' />
          <Step.Content>
            <Step.Title>{`${valueForm && valueForm.status === 6 ? 'Cancelled' : valueForm && valueForm.status === 4 ? 'Completed' : 'Complete'}`}</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    </Cont>
  )

  function getStepActivity() {
    if ([4, 0].indexOf(valueForm && valueForm.status) >= 0) return null
    if (valueForm && valueForm.status === 5) return <Step.Description>{'Creator update information'}</Step.Description>
    let step = approvers && approvers.find(x => x.isCurrentStep)
    if (step) {
      return valueForm.statusActivity
      // <Step.Description>{step.stepName === 'GOA' ? `${step.stepName} Approval` : step.stepName}</Step.Description>
    } else {
      return null
    }
  }
}

const mapStateToProps = (state) => ({
  dpDetail: state.downPayment.downPaymentDetail.data,
  approvers: state.downPayment.approvers.data,
  valueForm: getFormValues('formDP')(state)
})
const mapDispatchToProps = {
  getDownPaymentApprover
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  connect((state, props) => ({
    history: props.history
  })),
  lifecycle({
    componentDidMount() {
    },
    componentWillReceiveProps(nextProp) {
    }
  })
)

export default enhance(DPStep)
